import React from 'react'
import { CircleUserRound } from 'lucide-react'
import { tokens } from '../../../assets/tokens'

const icon = props => <CircleUserRound size={18} color={tokens.color.text.tertiary} {...props} />

export default icon
